<div class="container">
  <div class="room-list mt-3 mb-3" *ngIf="roomClosures && roomClosures.length > 0">
    <table class="table table-striped table-responsive-lg">
      <thead>
      <tr>
        <th class="text-center">#</th>
        <th class="text-center">Office</th>
        <th class="text-center">Room</th>
        <th class="text-center">Start</th>
        <th class="text-center">End</th>
        <th></th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let roomClosure of roomClosures">
        <th class="text-center">{{ roomClosure.id }}</th>
        <td class="text-center">{{ getOffice(roomClosure.room.officeId) }}</td>
        <td class="text-center">{{ roomClosure.room.name }}</td>
        <td class="text-center">{{ roomClosure.start | date:'dd.MM.yyyy HH:mm' }}</td>
        <td class="text-center">{{ roomClosure.end | date:'dd.MM.yyyy HH:mm' }}</td>
        <td class="text-center">
          <button type="button" class="btn btn-light edit-button" (click)="openEditModal(roomClosure)">
            <i class="fas fa-pencil"></i>
          </button>
        </td>
        <td class="text-center">
          <button type="button" class="btn btn-danger delete-button" (click)="openDeleteConfirmModal(roomClosure)">
            <i class="fas fa-trash"></i>
          </button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <div class="text-center">
    <button type="button" class="btn btn-default add-button" (click)="openEditModal(null)">
      <i class="fas fa-plus"></i> Add new
    </button>
  </div>
</div>
